import React from 'react';
import './SizeButton.css';

const SizeButton = ({ size, isActive, onClick }) => {
  const handleClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    onClick && onClick(e);
  };

  return (
    <button
      type="button"
      className={`size-btn ${isActive ? 'active' : ''}`}
      onClick={handleClick}
    >
      {size}
    </button>
  );
};

export default SizeButton;



